import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { getDeviationTitle, getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import Title from '../_partials/Title';
import AdoptableOwner from '../_partials/AdoptableOwner';
import DeviationFlags from '../../ActionBar/buttons/DeviationFlags';
import s from './MobileSubmissionDetails.scss';
const MobileSubmissionDetails = ({ className , deviation , deviation: { dailyDeviation , premiumFolderData  } , showTitle  })=>{
    var _deviation_extended;
    const adoptablesEnabled = useFlag('adoptables');
    const deviationTitle = getDeviationTitle(deviation);
    const isTextual = [
        DeviationTypes.LITERATURE
    ].includes(getDeviationType(deviation));
    const { isPremium , isPaidFolder  } = normalizePremiumFolderData(premiumFolderData);
    const isPremiumNonLit = isPremium && !isTextual;
    const adoptable = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.adoptable;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, dailyDeviation && s['with-flag'])
    }, dailyDeviation && showTitle && /*#__PURE__*/ React.createElement("div", {
        className: s['flag']
    }, /*#__PURE__*/ React.createElement(DeviationFlags, {
        deviation: deviation
    })), isPremiumNonLit && /*#__PURE__*/ React.createElement(React.Fragment, null, isPaidFolder ? /*#__PURE__*/ React.createElement(Premium, {
        className: s['folder-icon'],
        size: IconSize.SMALL
    }) : /*#__PURE__*/ React.createElement(EyeDisc2, {
        className: s['folder-icon'],
        size: IconSize.SMALL
    })), /*#__PURE__*/ React.createElement(Title, {
        title: deviationTitle,
        showTitle: showTitle,
        className: classnames(s['title'], isPremiumNonLit && s['title-with-folder-icon'])
    }), adoptablesEnabled && adoptable && /*#__PURE__*/ React.createElement(AdoptableOwner, {
        className: s['adoptable-owner'],
        adoptable: adoptable
    }));
};
MobileSubmissionDetails.displayName = 'MobileSubmissionDetails';
export default MobileSubmissionDetails;
